exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-information-design-shortcut[data-v-714b8ab1]{padding:.5rem}.fts-information-design-shortcut .information-design-shorcut-toggle[data-v-714b8ab1]{padding:.375rem .75rem;border:1px solid transparent;border-radius:.25rem;font-size:.875rem;line-height:1.5;color:var(--fts-form-control-placeholder)}.fts-information-design-shortcut .information-design-shorcut-toggle[data-v-714b8ab1]:hover{background-color:var(--fts-gray-100)}", ""]);

// exports
